module.exports = __webpack_public_path__ + "img/tere2.892dc2dd.png";